import * as React from 'react';
import { Button, Dropdown, Form } from 'semantic-ui-react';
import { DropdownItem } from 'types/dropdown-item';
import { getI18n } from 'services/i18n-service';
import { hasPermissionTo } from 'helpers/permission-helper';
import { LanguageCode } from 'types/tenants/language-code';
import { Permission } from 'types/permission';
import { Mode } from 'types/mode';
import { Tenant } from 'types/tenants/tenant';
import { translations } from 'types/translations';
import 'pages/settings/styles.css';

export interface Props {
  isProcessing: boolean;
  isOnline: boolean;
  languageOptions: DropdownItem[];
  permissions: string;
  tenant: Tenant;
  setTenant: (tenant: Tenant) => void;
  updateTenantPreferences: () => void;
}

interface State { }

export class TenantPreferencesForm extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.getLanguage = this.getLanguage.bind(this);
    this.setLanguage = this.setLanguage.bind(this);
    this.isInvalid = this.isInvalid.bind(this);
  }

  public render() {
    const i18n = getI18n();

    const canUpdate: boolean =
      hasPermissionTo([Mode.Update], Permission.TenantPreferences, this.props.permissions);

    return (
      <Form>
        <Form.Field className="language-code-field">
          <label className="settings-label">{i18n.t(translations.Language)}</label>
          <Dropdown
            className="settings-dropdown"
            name="language-code-setting"
            selection={true}
            onChange={this.setLanguage}
            value={this.getLanguage()}
            options={this.props.languageOptions}
          />
        </Form.Field>
        {
          canUpdate ?
            <Button type="submit"
              className="save-button neutral button align-right"
              disabled={this.isInvalid(this.props.tenant.language) || this.props.isProcessing || !this.props.isOnline}
              loading={this.props.isProcessing}
              onClick={this.props.updateTenantPreferences}>
              {i18n.t(translations.Save)}
            </Button>
            : null
        }
      </Form>
    );
  }

  private getLanguage = () => {
    const result = this.props.languageOptions.filter((option: DropdownItem) => {
      return option.value === this.props.tenant.language;
    });
    const language = result.length > 0
      ? result[0].value
      : LanguageCode.Unknown;
    return language;
  }

  // tslint:disable-next-line:no-any
  private setLanguage(event: any, { value }: any): void {
    const LANGUAGE_MAX_LENGTH = 2;
    if (value.length <= LANGUAGE_MAX_LENGTH) {
      let tenant = Object.assign({}, this.props.tenant) as Tenant;
      tenant.language = value;
      this.props.setTenant(tenant);
    }
  }

  private isInvalid(text: string): boolean {
    return text === undefined ||
      text === null ||
      text === '';
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/tenant-preferences-form.tsx